<template>
  <p>rebate setting</p>
</template>
